import React from 'react';
import { Button, Result, Space } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getDefaultUserRoute } from '../../utils/userRoutes';
import { DefaultAdminPage } from '../../config';
import { normalizeLoginType } from '../../utils/auth';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.data);
  const loginType = normalizeLoginType(user?.loginType);

  const homeRoute =
    loginType === 'admin'
      ? DefaultAdminPage
      : loginType === 'user'
        ? getDefaultUserRoute(user)
        : '/sign-in';

  return (
    <div style={{ padding: '48px 24px' }}>
      <Result
        status="404"
        title={t('notFound.title', 'Page not found')}
        subTitle={t(
          'notFound.message',
          'The page you requested does not exist or may have moved.'
        )}
        extra={
          <Space wrap>
            <Button type="primary" onClick={() => navigate(homeRoute)}>
              {t('notFound.back', 'Back to Dashboard')}
            </Button>
            <Button onClick={() => navigate(-1)}>
              {t('notFound.goBack', 'Go back')}
            </Button>
          </Space>
        }
      />
      {process.env.NODE_ENV === 'development' ? (
        <div
          style={{
            textAlign: 'center',
            color: '#8c8c8c',
            fontSize: 12,
            marginTop: -16,
          }}
        >
          {location.pathname}
          {location.search}
        </div>
      ) : null}
    </div>
  );
}
